export default __webpack_public_path__ + "static/media/maintenanceBackground.6138c09d.png";